import React, {useState, useRef, useEffect,useImperativeHandle,forwardRef} from 'react'
import {Radio, Space, Input, Spin, Pagination} from "antd"
import CloudApi from "../../../cloud/cloud_api";
import Message from "../../../common/message";
import IconRightArrow from "../../iconfont/rightArrow/rightArrow";
const AddressBook = forwardRef(({
                         wxid:wxid,
                                    data:data,
                                    getContent:getContent,
                         chat_wxid:chat_wxid,
                         addressBookRef:addressBookRef,
                                    modifiedTotalData:modifiedTotalData
                     },ref)=>{
    const [testList, setTestLsit] = useState([]) //通讯录列表
    const [modalLoading, setModalLoading] = useState(false)
    const [radioValue, setRadioValue] = useState(1)
    const [total, setTotal] = useState(0) //分页总数
    const [defaultCurrent, setDefaultCurrent] = useState(1) //默认分页
    const [isClick , setIsClick ] = useState(false) //通过设置禁用点击事件
    const [radioDisabled, setRadioDisabled] = useState(false) // 禁用开关


    const options = [
        {label: '好友', value: 1},
        {label: '群聊', value: 2},
        {label: '成员', value: 3},
    ]
    useEffect(()=>{
        apiList(1, radioValue, '')
    },[wxid])
    //通讯录列表 接口, 页码 page, 当前分类radioValue, 模糊搜索值searchValue
    const apiList = (page, radioValue, searchValue) => {
        setModalLoading(true)
        if (radioValue == 1) {
            //好友接口
            let bodyData = {
                wxid: wxid,
                chat_wxid: chat_wxid,
                nickName: searchValue,
                sex: 9,
            }
            CloudApi.getChatGetCustomers(5, page, bodyData, data => {
                setTestLsit(data.list)
                setTotal(data.pagInfo.total)
                setModalLoading(false)
                setRadioDisabled(false)
            }, error => {
                // Message.error(error.respMsg)
                setModalLoading(false)
                setRadioDisabled(false)

            })
        } else if (radioValue == 2) {
            //群聊接口
            let queryParam = {pageSize: 5, pageNum: page}
            let bodyData = {
                groupName: searchValue,
                wxwUserId: wxid
            }
            CloudApi.getGroupManageList(queryParam, bodyData, data => {
                setTestLsit(data.list)
                setTotal(data.pagInfo.total)
                setModalLoading(false)
                setRadioDisabled(false)

            }, error => {
                setModalLoading(false)
                setRadioDisabled(false)

            })
        } else if (radioValue == 3) {
            //成员接口
            let bodyData = {
                wxid: wxid,
                chat_wxid: chat_wxid,
                nickName: searchValue,
            }
            CloudApi.getChatWorkMates(5, page, bodyData, data => {
                setTestLsit(data.list)
                setTotal(data.pagInfo.total)
                setModalLoading(false)
                setRadioDisabled(false)

            }, error => {
                setModalLoading(false)
                setRadioDisabled(false)

            })
        }
    }
    //切换分类 好友  群聊  成员
    const onChange = e => {
        let value = e.target.value
        setTotal(0)
        setRadioValue(value)
        setDefaultCurrent(1)
        apiList(1, value, '')
        setRadioDisabled(true)
    }
    //转发的模糊搜索  点击搜索图标、清除图标，或按下回车键的 回调
    const transSearch = (value, event) => {
        apiList(1, radioValue, value)
    }
    //分页回调
    const pageChange = (page, pageSize) => {
        apiList(page, radioValue, '')
    }
    //每次打开都是false
    function setClick(type) {
        setIsClick(type)
    }
    //点击发起聊天
    function aChatChange(item) {
        if(!isClick){
            let id=item.customerId ? item.customerId : `R:${item.roomId}`
            let whetherSession=data.filter(el=>el.chat_wxid==id)//发起聊天先判断有没有在会话列表中
            if(whetherSession.length>0){//有的话直接选中那个会话
                whetherSession[0].checked=true
                getContent(whetherSession[0])
                addressBookRef.hide()
            }else {//没有在新建
                let bodyData={
                    wxid:wxid,
                    chat_wxid:item.customerId ? item.customerId : item.roomId,
                    isRoom:item.customerId ? 1 : 2
                }
                CloudApi.getChatPostChat(bodyData,(list)=>{
                    list.checked=true
                    let newData = data
                    newData.forEach(item=>{
                        item.checked = false
                    })
                    newData.unshift(list)
                    modifiedTotalData(newData)
                    getContent(list)
                    addressBookRef.hide()
                },()=>{
                    // Message.error('发起聊天失败')
                })
            }
        }
        setIsClick(true)
    }
    useImperativeHandle(ref,()=>({
        setClick:setClick
    }))
    return(
        <div className={'address_book'}>
            <div className={'forward-modal-header'}>
                <Radio.Group
                    className={'forward-modal-radio'}
                    options={options}
                    onChange={onChange}
                    value={radioValue}
                    disabled={radioDisabled}
                    optionType="button"
                />
                <Space>
                    <Input.Search placeholder="请输入要查找的昵称" onSearch={transSearch} allowClear style={{width: 255}}/>
                </Space>
            </div>
            <Spin spinning={modalLoading}>
                <div className={'address_book_list'}>
                    {
                        testList.map((item,index)=>(
                            <div key={index} onClick={aChatChange.bind(this,item)}>
                                <div>
                                    <img src={item.avatar || item.avatorUrl}/>
                                    <div className={'address_book_name_and_firm'}>
                                        <span className={'address_book_name'}>{item.nickName || item.roomName}</span>
                                        {
                                            item.corpName ? <span className={item.corpName == '微信' ? 'wx_name address_book_firm' : 'qy_name address_book_firm'}>@{item.corpName}</span> : ''
                                        }
                                    </div>
                                </div>
                                <span><IconRightArrow/></span>
                            </div>
                        ))
                    }
                </div>
                {
                    total > 5 ?
                        <Pagination
                            className={'im-forward-page'}
                            total={total}
                            defaultCurrent={defaultCurrent}
                            pageSize={5}
                            showSizeChanger={false}
                            showQuickJumper
                            onChange={pageChange}
                        /> : ''
                }
            </Spin>
        </div>
    )
})
export default AddressBook